$(function() {
	function progressBarHandler(carousel, progressBar) {
		var count = parseInt(carousel.data('elementCount') || '1') - 1;
		var current = parseInt(carousel.data('elementCurrent') || '0');
		if (count > 0) progressBar.css('width', (current / count) * 100 + '%');
		else if (count == 0) {
			progressBar.css('width', '100%');
		} else {
			progressBar.css('width', '0%');
		}
	}

	function initSportsCarousel() {
		var sportsCarousel = $('*[id*=pl_ig_carousel]:visible');
		sportsCarousel.each(function() {
			var id = $(this).attr('id');
			var lastChar = id.substr(id.length - 1);
			const pb = $('#pl_ig-pb' + lastChar + '-m');
			$(this).data('elementCurrent', 0);
			$(this).data(
				'elementCount',
				$('#' + id + ' .carousel-inner .carousel-item').length
			);
			$(this).on('slide.bs.carousel', function(data) {
				$(this).data('elementCurrent', data.to);
				progressBarHandler($(this), pb);
			});
		});
	}

	initSportsCarousel();
});
